import { Region } from './region'
import { User } from './user'

export enum NonResidentStatus {
  INITED = 'inited',
  CONSIDERATION = 'consideration',
  ON_FIX = 'on_fix',
  SUCCESS = 'success',
  FAIL = 'fail',
  DECLINED = 'declined',
  ERROR = 'error',
}

export type NonResidentCardObject = {
  id: number
  number: string
  type: string
}

export interface NonResidentObject {
  id: number
  name: string
  surname: string
  middle_name: string
  birthdate: string
  client_photo: string
  inn: string
  document_number: string
  issuing_authority: string
  expire_date: string
  is_identified: boolean
  pan: string
  grs_photo: string
  live_photo: string
  ui_photo: string
  status: NonResidentStatus
  consultant?: User
  created_at: string
  card: NonResidentCardObject
  notarized_passport_back: string
  notarized_passport: string
  passport: string
  stay_document: string
  anketa_photos?: Array<{
    file: string
    id: number
  }>
  controller_comment: string | null
  region: Region
}

export interface NonResidentShortObject {
  client_full_name: string
  created_at: string
  document_number: string
  controller_comment?: string
  consultant: { first_name: string; last_name: string; middle_name?: string }
  card: NonResidentCardObject
  inn?: string
  region: Region
  id: number
  status: NonResidentStatus
}
